import styles from './TrafficLightStatusIndicator.module.scss';

import { Box } from '@mui/material';
import clsx from 'clsx';

import { TrafficLightStatus } from '@work4all/models/lib/Enums/TrafficLightStatus.enum';

const STATUSES = [
  TrafficLightStatus.RED,
  TrafficLightStatus.YELLOW,
  TrafficLightStatus.GREEN,
];

type Props = {
  value: TrafficLightStatus;
};

export const TrafficLightStatusIndicator = ({ value }: Props) => {
  return (
    <Box className={styles.container}>
      {STATUSES.map((status) => {
        return (
          <Box
            key={status}
            className={clsx(styles.status, {
              [styles[status]]: status === value,
            })}
          />
        );
      })}
    </Box>
  );
};
